var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
            React.createElement("path", { d: "M31.21 27.997l4.153 4.153a2.175 2.175 0 01-3.076 3.076l-4.153-4.154a2.215 2.215 0 01-.05-.051 10.539 10.539 0 01-5.613 1.605C16.688 32.626 12 28.01 12 22.313 12 16.617 16.688 12 22.471 12s10.471 4.617 10.471 10.313c0 2.1-.637 4.054-1.732 5.684zM22.47 30.2c4.422 0 8.007-3.531 8.007-7.887 0-4.355-3.585-7.886-8.007-7.886s-8.007 3.53-8.007 7.886S18.049 30.2 22.47 30.2z", fill: "currentColor", fillRule: "nonzero" }),
            React.createElement("path", { d: "M27.5 22.375v.25c0 .621-.448 1.125-1 1.125h-8c-.552 0-1-.504-1-1.125v-.25c0-.621.448-1.125 1-1.125h8c.552 0 1 .504 1 1.125z", fill: "currentColor", fillRule: "nonzero" }))));
});
